import { render, staticRenderFns } from "./CheckDoc.vue?vue&type=template&id=9a19f47c&"
import script from "./CheckDoc.vue?vue&type=script&setup=true&lang=js&"
export * from "./CheckDoc.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CheckDoc.vue?vue&type=style&index=0&id=9a19f47c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports